/**
 * 枚举类
 */
class Enum {
    /**
     * 添加枚举字段
     * field: 枚举字段
     * label: 界面显示
     * value: 枚举值
     */
    add(field, label, value) {
        this[field] = { label, value }
        return this
    }

    /**
     * 根据枚举value获取其label
     */
    getLabel(value) {
        // 字段不存在返回‘’
        if (value === undefined || value === null) {
            return ''
        }
        for (let i in this) {
            let e = this[i]
            if (e && e.value === value) {
                return e.label
            }
        }
        return ''
    }
}

// 一体机状态
var deviceStatus = new Enum()
    .add('Unknown', '未知', 0)
    .add('Running', '打开', 1)
    .add('Shutdown', '关闭', 2)
    .add('Breakdown', '故障', 3)
    .add('Other', '其他', 4);

// 人体感应状态
var bodySensorStatus = new Enum()
    .add('Unknown', '未知', 0)
    .add('HasPerson', '有人', 1)
    .add('Nobody', '无人', 2);

var alarmType = new Enum()
    .add('Unknown', '未知', 0)
    .add('AnalyzeTimeout', '分析报警', 1)
    .add('InventoryTimeout', '超时报警', 2)
    .add('InventoryOverflow', '超量报警', 3)
    .add('SoundLightAlarm', '现场报警', 4)
    .add('DeviceErrorAlarm', '故障报警', 5);

var manifestLifeCycle = new Enum()
    .add('Unknown', '未知', -1)
    .add('Applying', '申请联单', 0)
    .add('TransportConfirm', '运输确认', 1)
    .add('WeighingOfEmptyCar', '空车过磅', 2)
    .add('ConfirmWeightOfEmptyCar', '确认空车重量', 3)
    .add('ConfirmInCar', '确认上车', 4)
    .add('WeighingOfFullCar', '载货过磅', 5)
    .add('ConfirmWeightOfFullCar', '确认载货重量', 6)
    .add('StartNavigation', '开始导航', 7)
    .add('ConfirmArrival', '确认到达', 8)
    .add('WeighingOfArrival', '到达过磅', 9)
    .add('Completed', '已完结', 10);

export default {
    deviceStatus,
    bodySensorStatus,
    alarmType,
    manifestLifeCycle
};